import events from '~/modules/game-events/game-events';
import { useEventListenerSelector } from '~/modules/game-events/hooks';
import { LOCAL_PLAYER_NUMBERS } from '~/modules/players/player-number';
import PlayersManager from '~/modules/players/players-manager';
import InputSources from '~/routes/select-input/input-sources/index';
import { slotState } from '~/routes/select-input/slot-state';

/**
 * Every slot the setup screen draws, whether or not a player exists behind them: a room with two
 * players still has to be shown where the others would go.
 */
export default function useMicSlots() {
  return useEventListenerSelector(
    [
      events.inputListChanged,
      events.playerInputChanged,
      events.playerAdded,
      events.playerRemoved,
      events.playerNameChanged,
    ],
    () =>
      LOCAL_PLAYER_NUMBERS.map((number) => {
        const player = PlayersManager.getPlayer(number);
        // A phone that has gone away is a state worth showing, so remote inputs are looked up
        // without the fallback; a local device that isn't in the list yet is just a list that
        // hasn't loaded, so those keep it.
        const input = player
          ? InputSources.getInputForPlayerSelected(player.input, player.input.source !== 'Remote Microphone')
          : null;

        return slotState(number, player, input);
      }),
  );
}
